<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" :before-close="beforeClose" class="dialog-w50">
    <h2 class="text-center mt-0">Сформировать отчет</h2>

    <div class="row mt-4">
      <h3 class="col-12 mb-3">Дата оказания услуги</h3>
      <div class="col-6">
        <el-date-picker v-model="fromDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                        class="w-100" placeholder="с" :pickerOptions="pickerOptions('fromDate')" />
      </div>
      <div class="col-6">
        <el-date-picker v-model="toDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                        class="w-100" placeholder="по" :pickerOptions="pickerOptions('toDate')" />
      </div>
    </div>

    <div class="row mt-4">
      <h3 class="col-12 mb-3">Дата создания рекламации</h3>
      <div class="col-6">
        <el-date-picker v-model="fromClaimCreatedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                        class="w-100" placeholder="с" :pickerOptions="pickerOptions('fromClaimCreatedDate')" />
      </div>
      <div class="col-6">
        <el-date-picker v-model="toClaimCreatedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                        class="w-100" placeholder="по" :pickerOptions="pickerOptions('toClaimCreatedDate')" />
      </div>
    </div>

    <div class="row mt-4">
      <h3 class="col-12 mb-3">Дата обработки рекламации</h3>
      <div class="col-6">
        <el-date-picker v-model="fromClaimProcessedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                        class="w-100" placeholder="с" :pickerOptions="pickerOptions('fromClaimProcessedDate')" />
      </div>
      <div class="col-6">
        <el-date-picker v-model="toClaimProcessedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                        class="w-100" placeholder="по" :pickerOptions="pickerOptions('toClaimProcessedDate')" />
      </div>
    </div>

    <h3 class="mt-4 mb-3">Выберите столбцы для отчета:</h3>

    <el-checkbox class="mb-2" :value="allSelected" @change="onAllSelected" label="">Выделить все</el-checkbox>

    <div class="column-count-2">
      <el-checkbox-group v-model="params">
        <div v-for="item in reportItems" :key="item.key" class="py-2">
          <el-checkbox :label="item.key">{{ item.label }}</el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <div class="row mt-5">
      <div class="col-12 col-lg-6 mx-auto">
        <el-button class="w-100" type="primary" @click="onSubmit" :loading="importExportProgress">
          Выгрузить в Excel
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { saveAs } from 'file-saver';

const reportItems = [
  { key: 'includeIsClaimProcessed', label: 'Обработка' },
  { key: 'includeContractor', label: 'Подрядчик' },
  { key: 'includeWorker', label: 'Исполнитель' },
  { key: 'includeWorkDate', label: 'Дата оказания услуги' },
  { key: 'includeService', label: 'Тип заказа' },
  { key: 'includeRegistryType', label: 'Тип реестра' },
  { key: 'includeShop', label: 'Магазин' },
  { key: 'includeClientName', label: 'Клиент' },
  { key: 'includeCancellationReason', label: 'Причина отмены' },
  { key: 'includeClaimReason', label: 'Причина рекламации' },
  { key: 'includeStatusReason', label: 'Причина ложного выезда' },
  { key: 'includeAddress', label: 'Адрес' },
  { key: 'includeServiceDetail', label: 'Детализация услуги' },
  { key: 'includeNumber', label: 'Номер заказа' },
  { key: 'includeStatus', label: 'Статус заказа' },
  { key: 'includeClaimCreationDate', label: 'Дата рекламации' },
  { key: 'includeClaimProcessingDate', label: 'Дата обработки' },
  { key: 'includeClaimProcessingComment', label: 'Комментарий к обработке' },
  { key: 'includeAttachedFile', label: 'Наличие вложений' },
  { key: 'includeGoodsSum', label: 'Сумма по товарам' },
  { key: 'includeServicesSum', label: 'Сумма по артикулам услуг' },
  { key: 'includeSalesOrders', label: 'Заказы на продажу' },
];

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      params: [],

      fromDate: null,
      toDate: null,

      fromClaimCreatedDate: null,
      toClaimCreatedDate: null,

      fromClaimProcessedDate: null,
      toClaimProcessedDate: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      importExportProgress: 'orders/importExportProgress',
    }),
    reportItems() {
      return reportItems.filter((x) => !(x.key === 'includeClientName' && this.user.userRole === this.$userRoles.Dispatcher));
    },

    allSelected() {
      return this.params.length === this.reportItems.length;
    },
  },
  methods: {
    ...mapActions({
      exportReport: 'orders/exportReport',
    }),
    pickerOptions(key) {
      const options = {
        firstDayOfWeek: 1,
      };
      const oneDayMs = 60 * 60 * 24 * 1000;

      switch (key) {
        case 'fromDate': options.disabledDate = (time) => time.getTime() > Date.parse(this.toDate); break;
        case 'toDate': options.disabledDate = (time) => time.getTime() < Date.parse(this.fromDate) - oneDayMs; break;

        case 'fromClaimCreatedDate': options.disabledDate = (time) => time.getTime() > Date.parse(this.toClaimCreatedDate); break;
        case 'toClaimCreatedDate': options.disabledDate = (time) => time.getTime() < Date.parse(this.fromClaimCreatedDate) - oneDayMs; break;

        case 'fromClaimProcessedDate': options.disabledDate = (time) => time.getTime() > Date.parse(this.toClaimProcessedDate); break;
        case 'toClaimProcessedDate': options.disabledDate = (time) => time.getTime() < Date.parse(this.fromClaimProcessedDate) - oneDayMs; break;
        default:
      }

      return options;
    },
    beforeClose(done) {
      if (!this.importExportProgress) {
        done();
      }
    },
    onAllSelected(value) {
      this.params = value ? this.reportItems.map((r) => r.key) : [];
    },
    onSubmit() {
      const params = {};
      if (this.fromDate) params.fromDate = this.fromDate;
      if (this.toDate) params.toDate = this.toDate;

      if (this.fromClaimCreatedDate) params.fromClaimCreatedDate = this.fromClaimCreatedDate;
      if (this.toClaimCreatedDate) params.toClaimCreatedDate = this.toClaimCreatedDate;

      if (this.fromClaimProcessedDate) params.fromClaimProcessedDate = this.fromClaimProcessedDate;
      if (this.toClaimProcessedDate) params.toClaimProcessedDate = this.toClaimProcessedDate;

      this.params.forEach((key) => {
        params[key] = true;
      });

      this.exportReport({ params })
        .then((response) => {
          saveAs(response, `Отчет_${this.$moment().format('DD-MM-YYYY_HH-mm-SS')}.xlsx`);
          this.$emit('update:visible', false);
        });
    },
  },
};
</script>
